<template>
  <div class="my-0 mx-auto relative w-full max-w-full overflow-x-hidden">
    <div class="min-h-0 box-border w-full my-0 mx-auto">
      <div class="relative mx-2 px-0" id="reflexion_guideline_card_container">
        <reflexion-guideline-response-component
          v-for="assessment in reflexionGuidelineAssessments"
          :key="assessment._id"
          :assessment="assessment"
        />
        <div v-if="reflexionGuidelineAssessments.length === 0" class="py-6">
          <h2 class="text-gray-700 mb-2">
            {{ $t('ReflexionGuideline.noReflexionGuidelines', { text: featureName }) }}
          </h2>
          <p class="text-gray-500">
            {{ $t('ReflexionGuideline.noReflexionGuidelinesMessage', { text: featureName }) }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ReflexionGuidelineResponseComponent from './ReflexionGuidelineResponseComponent.vue';
import { getFeatureDisplayNameOrFallback } from '@/utils/featureDisplay';

export default {
  name: 'ReflexionGuidelineComponent',
  props: [],
  components: { ReflexionGuidelineResponseComponent },
  data() {
    return {};
  },
  computed: {
    featureName() {
      return getFeatureDisplayNameOrFallback(
        this.$store,
        'reflexionGuideline',
        this.$t('FallbackTexts.reflectionGuideline'),
        this.$i18n?.locale,
      );
    },
    reflexionGuidelineAssessments() {
      const reflexionGuideline = this.$store.getters.getReflexionGuidelineAssessments;
      if (!reflexionGuideline || reflexionGuideline.length === 0) {
        return [];
      }
      return reflexionGuideline;
    },
  },
  async mounted() {
    await this.$store.dispatch('getReflexionGuidelineAssessments');
  },
};
</script>
